import { gql } from '@apollo/client'
import React from 'react'

import { generalClient } from '../../../utils/apollo/api'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useConfigsState = () => React.useContext(Context)
export const useConfigs = () => useConfigsState()?.configs || []

export const useConfig = configName => {
  const configs = useConfigs()
  return configs.find(c => c.name === configName)
}

const QUERY = gql`
  query Configs {
    configs {
      id
      name
      value
      updatedAt
      insertedAt
    }
  }
`

const ConfigsLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: {},
    client: generalClient,
    fetchPolicy: 'cache-first'
  })

  return (
    <StatePresenter {...state} noEmptyMessage empty={false}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ConfigsLoader
